// extracted by mini-css-extract-plugin
export var activityContainer = "_m5-0";
export var typingIndicatorContainer = "_m5-1";
export var typingIndicatorDot = "_m5-2";
export var wave = "_m5-3";